import {Injectable} from "@angular/core";

export const Averages = {
  'lol': {
    divisions: [
      0,
      5,  // Iron IV
      5,  // Iron III
      5,  // Iron II
      5,  // Iron I
      5,  // Bronze IV
      5,  // Bronze III
      5,  // Bronze II
      5,  // Bronze I
      6,  // Silver IV
      6,  // Silver III
      6,  // Silver II
      6,  // Silver I
      7,  // Gold IV
      7,  // Gold III
      7,  // Gold II
      7,  // Gold I
      8,  // Platinum IV
      8,  // Platinum III
      8,  // Platinum II
      10, // Platinum I
      12, // Emerald IV
      12, // Emerald III
      12, // Emerald II
      12, // Emerald I
      14, // Diamond IV
      14, // Diamond III
      14, // Diamond II
      18, // Diamond I
      20, // Master
      22, // Grandmaster
      25, // Challenger
    ],
    placements : 1,
    netwins: [
      0,
      1,  // Iron IV
      1,  // Iron III
      1,  // Iron II
      1,  // Iron I
      1,  // Bronze IV
      1,  // Bronze III
      1,  // Bronze II
      1,  // Bronze I
      1,  // Silver IV
      1,  // Silver III
      1,  // Silver II
      1,  // Silver I
      1,  // Gold IV
      1,  // Gold III
      1,  // Gold II
      1,  // Gold I
      1,  // Platinum IV
      1,  // Platinum III
      1,  // Platinum II
      1, // Platinum I
      1.5, // Emerald IV
      1.5, // Emerald III
      1.5, // Emerald II
      1.5, // Emerald I
      1.5, // Diamond IV
      1.5, // Diamond III
      1.5, // Diamond II
      1.5, // Diamond I
      2, // Master
      2, // Grandmaster
    ],
    games : 1,
    normalgames : 1,
    leveling:{
      0:3,
      30:3.5,
      50:5
    },
    masteries:[
      1,
      3,
      6,
      10,
      14,
      1.5,
      1.5,
      1.5,
      1.5,
      1.5
    ]

  },
  'tft': {
    divisions: [
      0,
      3,  // Iron IV
      3,  // Iron III
      3,  // Iron II
      3,  // Iron I
      3,  // Bronze IV
      3,  // Bronze III
      3,  // Bronze II
      3,  // Bronze I
      4,  // Silver IV
      4,  // Silver III
      4,  // Silver II
      4,  // Silver I
      5,  // Gold IV
      5,  // Gold III
      6,  // Gold II
      6,  // Gold I
      8,  // Platinum IV
      8,  // Platinum III
      10, // Platinum II
      10, // Platinum I
      12, // Emerald IV
      12, // Emerald III
      12, // Emerald II
      12, // Emerald I
      14, // Diamond IV
      14, // Diamond III
      14, // Diamond II
      16, // Diamond I
      72, // Master
      22, // Grandmaster
      25, // Challenger
    ],
    placements: 1,
    netwins: [
      0,
      1,  // Iron IV
      1,  // Iron III
      1,  // Iron II
      1,  // Iron I
      1,  // Bronze IV
      1,  // Bronze III
      1,  // Bronze II
      1,  // Bronze I
      1,  // Silver IV
      1,  // Silver III
      1,  // Silver II
      1,  // Silver I
      1,  // Gold IV
      1,  // Gold III
      1,  // Gold II
      1,  // Gold I
      1,  // Platinum IV
      1,  // Platinum III
      1,  // Platinum II
      1, // Platinum I
      1, // Diamond IV
      1, // Diamond III
      1, // Diamond II
      1, // Diamond I
      1, // Master
      1, // Grandmaster
    ],
    normalgames: 1,
    doubleup: [
      0,
      3,  // Iron IV
      3,  // Iron III
      3,  // Iron II
      3,  // Iron I
      3,  // Bronze IV
      3,  // Bronze III
      3,  // Bronze II
      3,  // Bronze I
      4,  // Silver IV
      4,  // Silver III
      4,  // Silver II
      4,  // Silver I
      5,  // Gold IV
      5,  // Gold III
      6,  // Gold II
      6,  // Gold I
      8,  // Platinum IV
      8,  // Platinum III
      10, // Platinum II
      10, // Platinum I
      12, // Emerald IV
      12, // Emerald III
      12, // Emerald II
      12, // Emerald I
      14, // Diamond IV
      14, // Diamond III
      14, // Diamond II
      16, // Diamond I
      72, // Master
      22, // Grandmaster
      25, // Challenger
    ],
  },
  'valorant': {
    divisions: [
      0,
      5,  // Iron 1
      5,  // Iron 2
      5,  // Iron 3
      5,  // Bronze 1
      5,  // Bronze 2
      5,  // Bronze 3
      5,  // Silver 1
      5,  // Silver 2
      5,  // Silver 3
      5,  // Gold 1
      5,  // Gold 2
      5,  // Gold 3
      5,  // Platinum 1
      5,  // Platinum 2
      5,  // Platinum 3
      8,  // Diamond 1
      8,  // Diamond 2
      8,  // Diamond 3
      10, // Ascendant 1
      10, // Ascendant 2
      10, // Ascendant 3
      12, // Immortal 1
      20, // Immortal 2
      48, // Immortal 3
    ],
    placements: 1,
    netwins: [
      0,
      1,  // Iron 1
      1,  // Iron 2
      1,  // Iron 3
      1,  // Bronze 1
      1,  // Bronze 2
      1,  // Bronze 3
      1,  // Silver 1
      1,  // Silver 2
      1,  // Silver 3
      1,  // Gold 1
      1,  // Gold 2
      1,  // Gold 3
      1,  // Platinum 1
      1,  // Platinum 2
      1,  // Platinum 3
      1,  // Diamond 1
      1.3,  // Diamond 2
      1.4,  // Diamond 3
      1.4, // Ascendant 1
      1.4, // Ascendant 2
      1.4, // Ascendant 3
      1.6, // Immortal 1
      1.7, // Immortal 2
      1.8, // Immortal 3
      2, // Immortal 3
    ],
    games : 1,
    normalgames : 1
  },
  'wild-rift':{
    divisions: [
      0,
      3,  // Iron IV
      3,  // Iron III
      3,  // Iron II
      5,  // Iron I
      4,  // Bronze IV
      4,  // Bronze III
      4,  // Bronze II
      6,  // Bronze I
      4,  // Silver IV
      4,  // Silver III
      4,  // Silver II
      6,  // Silver I
      5,  // Gold IV
      5,  // Gold III
      5,  // Gold II
      7,  // Gold I
      5,  // Platinum IV
      5,  // Platinum III
      5,  // Platinum II
      7, // Platinum I
      7, // Emerald IV
      7, // Emerald III
      7, // Emerald II
      9, // Emerald I
      7, // Diamond IV
      7, // Diamond III
      8, // Diamond II
      8, // Diamond I
      48, // Master
      72, // Grandmaster
      25, // Challenger
    ],
    placements : 1,
    normalgames : 1,
  },
  'codmw2':[],
  'codwz2':[],
  'overwatch':[],
  'cs2': {
    premier: [
      5,  // 0
      5,  // 1000
      6,  // 2000
      6,  // 3000
      6,  // 4000
      7,  // 5000
      7,  // 6000
      7,  // 7000
      7,  // 8000
      8,  // 9000
      8,  // 10000
      8,  // 11000
      9,  // 12000
      9,  // 13000
      10,  // 14000
      11,  // 15000
      12,  // 16000
      13,  // 17000
      14,  // 18000
      15,  // 19000
      16,  // 20000
      18,  // 21000
      19,  // 22000
      20,  // 23000
      20,  // 24000
      22,  // 25000
      22,  // 26000
      22,  // 27000
      22,  // 28000
      29,  // 29000
      46,  // 30000
      46,  // 31000
      46,  // 32000
      46,  // 33000
      46,  // 34000
      46   // 35000
    ],
    competitive:[
      5,  // Unranked
      5,  // Silver I
      5,  // Silver II
      5,  // Silver III
      5,  // Silver IV
      6,  // Silver Elite
      6,  // Silver Elite Master
      7,  // Gold Nova I
      7,  // Gold Nova II
      8,  // Gold Nova III
      8, // Gold Nova Master
      10, // Master Guardian I
      12, // Master Guardian II
      14, // Master Guardian Elite
      16, // Distinguished Master Guardian
      18, // Legendary Eagle
      20, // Legendary Eagle Master
      22, // Supreme Master First Class
      26, // Global Elite
    ],
    placements: 1,
    netwins: [
      0,
      1,  // Iron 1
      1,  // Iron 2
      1,  // Iron 3
      1,  // Bronze 1
      1,  // Bronze 2
      1,  // Bronze 3
      1,  // Silver 1
      1,  // Silver 2
      1,  // Silver 3
      1,  // Gold 1
      1,  // Gold 2
      1,  // Gold 3
      1,  // Platinum 1
      1,  // Platinum 2
      1,  // Platinum 3
      1,  // Diamond 1
      1.3,  // Diamond 2
      1.4,  // Diamond 3
      1.4, // Ascendant 1
      1.4, // Ascendant 2
      1.4, // Ascendant 3
      1.6, // Immortal 1
      1.7, // Immortal 2
      1.8, // Immortal 3
      2, // Immortal 3
    ],
    games : 1,
    normalgames : 1
  },
  apex: {
    divisions: [
      2,
      2,
      2,
      2,
      2,5,
      2,5,
      2,5,
      2,5,
      3,
      3,
      3,
      3,
      3,5,
      3,5,
      3,5,
      3,5,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
    ],
    placements: 0.5,
    badges: [
      2,
      1,
      1,
      1,
      2,
      2,
      4,
      4,
      4,
      4,
      3,
      2,
      2,
      2,
      1,
      1,
      4,
      2,
      2,
      3,
      5,
      8,
      12,
      3,
      2,
      3,
      36,
      84,
      4,
      8,
      12,
      24,
      2,
      5,
      8,
      3,
    ],
    normalgames: 1
  },
  marvel: {
    divisions: [
      0, //'Unranked'
      5, //'Bronze III'
      5, //'Bronze II'
      5, //'Bronze I'
      5, //'Silver III'
      5, //'Silver II'
      5, //'Silver I'
      6, //'Gold III'
      6, //'Gold II'
      6, //'Gold I'
      6, //'Platinum III'
      6, //'Platinum II'
      6, //'Platinum I'
      8, //'Diamond III'
      8, //'Diamond II'
      8, //'Diamond I'
      10, //'Grandmaster III'
      10, //'Grandmaster II'
      10, //'Grandmaster I'
      12, //'Celestial III'
      12, //'Celestial II'
      12, //'Celestial I'
      20, //'Eternity'
      25, //'One Above All'
    ],
    normalgames: 1,
    netwins: [
      0, //'Unranked'
      1, //'Bronze III'
      1, //'Bronze II'
      1, //'Bronze I'
      1, //'Silver III'
      1, //'Silver II'
      1, //'Silver I'
      1, //'Gold III'
      1, //'Gold II'
      1, //'Gold I'
      1, //'Platinum III'
      1, //'Platinum II'
      1, //'Platinum I'
      2, //'Diamond III'
      2, //'Diamond II'
      2, //'Diamond I'
      2, //'Grandmaster III'
      2, //'Grandmaster II'
      2, //'Grandmaster I'
      2, //'Celestial III'
      2, //'Celestial II'
      2, //'Celestial I'
      2, //'Eternity'
      25, //'One Above All'
    ],
    leveling:{
      0: 1,
    },
  }
};
@Injectable()
export class AverageCompletionService {

  public static getEstimateTimes(service) {

    let game = service.game;

    let totalHours = 0;

    let gameService = service.service;
    if(gameService === 'divisions' || gameService === 'doubleup') {
      if(game === 'cs2'){
        gameService = service.queue;
      }

      // let's calculate the current first
      totalHours += Averages[game][gameService][service.current];

      // let's calculate the rest of the divisions if there's more
      for (let i = service.current + 1; i < service.desired; i++) {
        totalHours += Averages[game][gameService][i];
      }

    } else if(gameService === 'masteries'){

      if(game === 'cs2'){
        gameService = service.queue;
      }

      // let's calculate the current first
      totalHours += Averages[game][gameService][service.current];

      // let's calculate the rest of the divisions if there's more
      if (gameService === gameService) {
        for (let i = service.current + 1; i < service.desired; i++) {
          totalHours += Averages[game][gameService][i];
        }
      }

    } else if(gameService === 'placements'){
      totalHours += Averages[game][gameService]*service.desired;
    } else if(gameService === 'badges'){
      totalHours += Averages[game][gameService][service.desired];
    } else if(gameService === 'games'){
      totalHours += Averages[game][gameService]*service.desired;
    } else if(gameService === 'normalgames'){
      totalHours += Averages[game][gameService]*service.desired;
    } else if(gameService === 'netwins'){
      totalHours += Averages[game][gameService][service.current]*service.desired;
    } else if(gameService === 'leveling'){

      for (let i = service.current; i < service.desired; i++) {

        if(i<=30){
          totalHours += Averages[game][gameService][0];
        } else if(i<=50){
          totalHours += Averages[game][gameService][30];
        } else{
          totalHours += Averages[game][gameService][50];
        }
      }
    }

    if(service.isExpress){
      totalHours = totalHours*0.8;
    }

    if (totalHours <= 48) {
      const tHours = Math.round(totalHours);
      return tHours + ' hour' + (tHours > 1 ? 's' : ''); // rounds to nearest whole number
    } else {
      let totalDays = Math.ceil(totalHours / 24); // rounds up to next whole number
      return totalDays + 'day' + (totalDays > 1 ? 's' : '');
    }

  }
}
